import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import BuscarEmpleado from '../BuscarEmpleado';
import axios from 'axios';
const server = process.env.REACT_APP_SERVER;


function NuevoComunicado({ regional, cerrarModal, tipo }) {
    const [alcances, setAlcances] = useState([]);
    const [lista, setLista] = useState([]);
    const [destinatarios, setDestinatarios] = useState([]);
    const [subAlcance, setSubAlcance] = useState(0);
    const [idAlcance, setIdAlcance] = useState(0);
    const [showModal1, setShowModal1] = useState(false);
    const [modalSelector, setModalSelector] = useState(false);
    const [selectEmpleado,setSelectEmpleado] = useState({});
    const [descripcion, setDescripcion] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [mode, setMode] = useState(false);
    const [documento, setDocumento] = useState([]);
    const [adjuntos, setAdjuntos] = useState([]);
    const [autorcom, setAutorcom] = useState('');
    const [todasSucursales, setTodasSucursales] = useState(false);
    const handleClose = (value) => {
        if (value == false) {
            setShowModal1(false);
        }
    };
    const handleShow = () => {
        setShowModal1(true)
    };
    const activarDestinatario = (e) => {
        if(e.target.id == 4){
            setTodasSucursales(true);
        }
        setIdAlcance(e.target.id);
        var elegido = alcances.filter((item) => item.ID_ALCANCE == e.target.id)[0];
        var exiteDestino = destinatarios.filter((item) => item.ID_ALCANCE == e.target.id);
        if (elegido.info.length !== 0) {
            setLista(elegido.info);
            setModalSelector(true);
        } else {
            if (exiteDestino.length == 0) {
                setLista([]);
                console.log(elegido);
                if (elegido.ID_ALCANCE == 3) {
                    var nombre = ''
                    if (regional == '990') {
                        nombre = 'CBBA';
                    } else {
                        nombre = 'SCZ';
                    }
                    setDestinatarios([...destinatarios, { "ID": elegido.ID_ALCANCE + regional, "ID_ALCANCE": elegido.ID_ALCANCE, "ID_VALOR": regional, "NOMBRE": nombre }]);
                } else if (elegido.ID_ALCANCE == 2) {
                    setDestinatarios([...destinatarios, { "ID": elegido.ID_ALCANCE + regional, "ID_ALCANCE": elegido.ID_ALCANCE, "ID_VALOR": regional, "NOMBRE": elegido.DESCRIPCION }])
                }else if (elegido.ID_ALCANCE == 8) {
                    handleShow();
                }
            } else {
                if(elegido.ID_ALCANCE!==8){
                    MsgUtils.msgError("Ya existe destinatario !!");
                } else if (elegido.ID_ALCANCE == 8) {
                    handleShow();
                }
            }
        }
    }
    const enviarMensaje = async () => {
        var info = JSON.parse(localStorage.getItem('info'));
        console.log("DESTINATARIOS")
        console.log(destinatarios)
        let nuevosDestinatarios= destinatarios.filter(item => item.ID != 41000);;
        console.log("NUEVOS DESTINATARIOS")
        console.log(nuevosDestinatarios)
        fetch(`${server}/comunicados/agregar/comunicado`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional,
                "destinatarios": nuevosDestinatarios,
                mensaje,
                descripcion,
                "idEmpleado": info.ID_EMPLEADO,
                "idSucursal": info.EMPRESA_SUCURSAL,
                mode,
                adjuntos,
                tipo,
                autorcom
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    MsgUtils.msgCorrecto(data.ok);
                    cerrarModal(false);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }

    const eliminarDestino = (e) => {
        let nuevoDestinatario;
        let destinatariosSinSucursales
        if (e.target.id == 41000) {

            destinatariosSinSucursales = destinatarios.filter((item) => item.ID_ALCANCE != 4)
            nuevoDestinatario = destinatariosSinSucursales.filter((item) => item.ID != e.target.id);
            console.log(destinatariosSinSucursales)
            setDestinatarios(nuevoDestinatario);

        } else {
            nuevoDestinatario = destinatarios.filter((item) => item.ID != e.target.id);
            setDestinatarios(nuevoDestinatario);
        }
    }
    const elegirSubAlcance = (e) => {

        var existeDestino = destinatarios.filter((item) => item.ID == idAlcance + e.target.value);

        if (existeDestino.length === 0) {
            if (e.target.value == 1000) {

                const haySucursales = destinatarios.some(destinatario => destinatario.ID_ALCANCE == 4);

                if (!haySucursales) {
                    console.log("NO HAY SUCURSALES")

                    setDestinatarios([...destinatarios, { "ID": idAlcance + 1000, "ID_ALCANCE": idAlcance + 1000, "ID_VALOR": 1000, "NOMBRE": 'Todas las sucursales' }])

                    let listaTodasSucursales = alcances.filter((item) => item.ID_ALCANCE == 4)[0].info
                    listaTodasSucursales.forEach(sucursal => {
                        setDestinatarios((prevDestinatarios) => [
                            ...prevDestinatarios,
                            {
                                "ID": idAlcance + sucursal.ID,
                                "ID_ALCANCE": idAlcance,
                                "ID_VALOR": sucursal.ID,
                                "NOMBRE": sucursal.NOMBRE
                            }
                        ]);
                    });

                    setModalSelector(false);
                    setTodasSucursales(false);
                }else{
                    console.log("YA HAY SUCURSALES")
                    setModalSelector(false);
                    setTodasSucursales(false);
                    MsgUtils.msgError("No puede seleccionar Todas las sucursales si ya selecciono una sucursal")
                }
            }else{
                let elegido = alcances.filter((item) => item.ID_ALCANCE == idAlcance)[0];
                var subAlcance = elegido.info.filter((item) => item.ID == e.target.value)[0];
                setSubAlcance(e.target.value);
                setDestinatarios([...destinatarios, { "ID": idAlcance + subAlcance.ID, "ID_ALCANCE": idAlcance, "ID_VALOR": subAlcance.ID, "NOMBRE": subAlcance.NOMBRE }])
                setModalSelector(false);
                setTodasSucursales(false)

            }
        } else {
            setModalSelector(false);
            setTodasSucursales(false);
            MsgUtils.msgError("Ya existe Destinatario !")

        }
    }
    const eliminarDocumento = (e) => {
        console.log(documento.findIndex(item => item.name != e.target.id));
        setDocumento(documento.filter(item => item.name != e.target.id));
    }
    const cargarArchivo = (e) => {
        var archiv = e.target.files[0];
        //console.log(archiv);
        setDocumento([...documento, archiv]);
        var id = JSON.parse(localStorage.getItem('info')).ID_EMPLEADO;
        var formData = new FormData()
        formData.append('FILE1', new Blob([archiv], { contentType: 'application/octet-stream', contentTransferEncoding: 'binary' }), archiv.name + '.' + id);
        try {
            axios.post(`http://172.19.51.3:4370`, formData, {
                'Accept': 'application/json',
                'content-type': 'multipart/form-data'
            }).then(res => { setAdjuntos([...adjuntos, res.data]); console.log(res.data) })
                .catch(error => console.log(error.message))
        } catch (error) {
            console.error('Error al subir el archivo !!');
        }
    }
    useEffect(() => {
        if (selectEmpleado.ID_EMPLEADO !=undefined) {
            var existeDestino = destinatarios.filter((item) => item.ID ==selectEmpleado.ID_EMPLEADO );
            if (existeDestino.length===0){
                setDestinatarios([...destinatarios, { "ID": '' + selectEmpleado.ID_EMPLEADO , "ID_ALCANCE": idAlcance, "ID_VALOR": selectEmpleado.ID_EMPLEADO , "NOMBRE": selectEmpleado.NOMBREX }])
                setSelectEmpleado({});
            }else{
                MsgUtils.msgError("Ya existe Destinatario !")
            }
        }
    }, [selectEmpleado])
    useEffect(() => {
        fetch(`${server}/comunicados/lista/alcances`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data.ok);
                setAlcances(data.ok);
            })
            .catch(err => MsgUtils.msgError(err));
    }, [])
    return (
        <div className=''>
            <div className='container-fluid bg-dark bg-gradient '>
                <div className='row row-cols-3 p-0 g-0'>
                    <div className='col col-sm-2'>
                        <a className='btn text-light p-0 m-0 fs-2'
                            onClick={() => cerrarModal(false)}>
                            <i className="fa-solid fa-circle-xmark"></i>
                        </a>
                    </div>
                    <div className='col text-light my-auto text-center'>{tipo === 'C' ? 'Creando Nuevo Comunicado' : 'Crear Nuevo Mensaje'}</div>
                </div>
            </div>
            <div className='container-fluid py-1'>
                <div className={tipo === 'C' ? "row mb-3" : 'd-none'}>
                    <label className="col-sm-2 col-form-label">De: </label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" placeholder='QUIEN ?'
                            value={autorcom}
                            onChange={(e) => setAutorcom(e.target.value)} />
                    </div>
                </div>
                <div className="mb-2">
                    <div className='row row-cols-2 g-1'>
                        <div className='col-10'>
                            <label for="exampleInputPassword1" className="form-label">Para: </label>
                        </div>
                        <div className='col-2 text-end'>
                            <div className="dropdown dropstart">
                                <button className="btn text-success" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="fa-solid fa-circle-plus fs-2"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton2">
                                    {alcances.map((item) => {
                                        return (
                                            <li key={item.ID_ALCANCE} onClick={activarDestinatario}><a className="dropdown-item" id={item.ID_ALCANCE}>{item.DESCRIPCION}</a></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='container-fluid py-1 bg-light rounded border-1'>
                        <div className='btn-group'>
                            {destinatarios.map((item) => {

                                const existeTodasSucursales = destinatarios.some(destinatario => destinatario.ID == 41000);
                            
                                if (existeTodasSucursales && item.ID_ALCANCE == 4) {
                                    return null;
                                } else {
                                    return (
                                        <div className='btn text-start' key={item.ID}>
                                            <span className="badge bg-secondary position-relative">
                                                {item.NOMBRE}
                                                <a className="btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                                    id={item.ID}
                                                    onClick={eliminarDestino}>
                                                    X
                                                </a>
                                            </span>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </div>
                <div className="input-group my-auto" style={{ height: "25px" }}>
                    <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>Asunto</span>
                    <input type="text" className="form-control"
                        placeholder='ASUNTO' style={{ height: "25px" }}
                        value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
                </div>
                <div className="form-floating mb-3 pt-2">
                    <textarea className="form-control"
                        placeholder="Leave a comment here"
                        value={mensaje}
                        onChange={(e) => setMensaje(e.target.value)}
                        style={{ height: "140px" }}>
                    </textarea>
                    <label for="floatingTextarea2" >Mensaje</label>
                </div>
                <div className="input-group my-auto" >
                    <span className="input-group-text bg-secondary bg-gradient text-light" >Reguiere Respuesta</span>
                    <select className=" form-select text-center "
                        value={mode ? '1' : '0'}
                        onChange={(e) => { e.target.value === '0' ? setMode(false) : setMode(true) }}>
                        <option value='0'>No</option>
                        <option value="1">Si</option>
                    </select>
                </div>
                <div className='container-fluid py-2'>
                    <div className='row row-cols-1 row-cols-sm-2 g-1'>
                        <div className='col col-sm-11'>
                            <div className='container px-4 bg-light'>
                                <span className='text'>Documentos Adjuntos</span>
                                <ul className="list-group bg-secondary">
                                    {documento.map((item) => {
                                        return (
                                            <li className="list-group-item position-relative" key={item.size}>
                                                {item.name}
                                                <button className='btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'
                                                    id={item.name}
                                                    onClick={eliminarDocumento}>
                                                    X
                                                </button>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className='col col-sm-1'>
                            <label className='btn fs-1 text-success'>
                                <i className="fa-solid fa-file-circle-plus"></i>
                                <input type="file" onChange={cargarArchivo} />
                            </label>
                        </div>
                    </div>
                </div>
                <button type="button" className="btn btn-secondary bg-gradient w-100" onClick={enviarMensaje}>enviar <i className="fa-solid fa-paper-plane"></i></button>
            </div>
            <Modal show={showModal1} onHide={() => handleClose(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName='modalNuevoC'>
                <Modal.Header closeButton>
                    <Modal.Title>Buscar Colaborador</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BuscarEmpleado setShowModal1={handleClose} setColaborador={setSelectEmpleado} reg={regional}/>
                </Modal.Body>
            </Modal>

            <Modal show={modalSelector} onHide={() => {setModalSelector(false); setTodasSucursales(false)}}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName='modalNuevoC'>
                <Modal.Header closeButton>
                    <Modal.Title>Seleccionar Destinatario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='forms-inputs'>
                        {lista.length !== 0 &&
                            <select className="form-select btn btn-secondary" value={subAlcance} onChange={elegirSubAlcance}>
                                <option value={0} >Ninguno</option>
                                {lista.map((item,index) => {
                                    return (
                                        <option value={item.ID} key={index} >{item.NOMBRE}</option>
                                    )
                                })}
                                {todasSucursales && <option value={1000} >Todas las sucursales</option>}
                            </select>}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default NuevoComunicado
